// Ajuste "Cerrar sesión al cerrar el navegador" (Settings → Register and login).
//
// El navegador no avisa que se cierra entero: para la página es lo mismo que cerrar su
// última pestaña. Cada pestaña abierta deja un "sigo viva" en localStorage; si al abrir
// la app ese aviso es viejo, no quedó ninguna pestaña abierta y la sesión se descarta.
// Una recarga o una pestaña nueva con otras abiertas ven el aviso fresco y siguen.
//
// No sirve una cookie de sesión ni sessionStorage: Chrome/Edge con "Continuar donde lo
// dejaste" restauran ambas, y sessionStorage además pediría login en cada pestaña nueva.

// Guarda los minutos de espera del tenant; sin la clave, el ajuste está apagado.
const FLAG_KEY = "logoutOnBrowserClose";
const ALIVE_KEY = "sessionAliveAt";
const BEAT_MS = 15000;
// Chrome limita los timers de las pestañas ocultas a uno por minuto: la espera tiene
// que cubrir eso o una ventana minimizada parecería cerrada.
const MIN_WAIT_MINUTES = 2;

// También al dar de alta un token: el aviso que dejó la sesión anterior es viejo y una
// recarga antes del primer latido borraría la sesión recién abierta.
export function markSessionAlive() {
  try {
    if (localStorage.getItem("token")) {
      localStorage.setItem(ALIVE_KEY, String(Date.now()));
    }
  } catch (e) {
    // localStorage bloqueado: sin sesión que cuidar
  }
}

// Antes de que arranque el router: si el tenant lo pide y no quedó ninguna pestaña viva,
// se borra la sesión igual que en un 401.
export function enforceLogoutOnBrowserClose() {
  try {
    const flag = localStorage.getItem(FLAG_KEY);
    if (!flag) return;
    if (!localStorage.getItem("token")) return;
    const waitMinutes = Math.max(MIN_WAIT_MINUTES, Number(flag) || 0);
    const aliveAt = Number(localStorage.getItem(ALIVE_KEY)) || 0;
    if (Date.now() - aliveAt > waitMinutes * 60 * 1000) {
      localStorage.clear();
    }
  } catch (e) {
    // localStorage bloqueado
  }
}

export function startSessionAliveBeat() {
  markSessionAlive();
  setInterval(markSessionAlive, BEAT_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") markSessionAlive();
  });
}

export function syncLogoutOnBrowserCloseFlag(settings) {
  if (!settings) return;
  try {
    if (settings.logoutOnBrowserClose === true) {
      localStorage.setItem(
        FLAG_KEY,
        String(Math.max(MIN_WAIT_MINUTES, Number(settings.logoutOnBrowserCloseMinutes) || 0))
      );
    } else {
      localStorage.removeItem(FLAG_KEY);
    }
  } catch (e) {
    // localStorage bloqueado
  }
}

// Settings muestra la espera en minutos u horas; el back la guarda en minutos.
export function logoutWaitFromMinutes(minutes) {
  const total = Math.max(MIN_WAIT_MINUTES, Math.round(Number(minutes) || 0));
  if (total % 60 === 0) {
    return { logoutOnBrowserCloseWaitValue: total / 60, logoutOnBrowserCloseWaitUnit: "hours" };
  }
  return { logoutOnBrowserCloseWaitValue: total, logoutOnBrowserCloseWaitUnit: "minutes" };
}

export function logoutWaitToMinutes(value, unit) {
  const minutes = Math.round((Number(value) || 0) * (unit === "hours" ? 60 : 1));
  return Math.max(MIN_WAIT_MINUTES, minutes);
}
